import { render, staticRenderFns } from "./handleInfo.vue?vue&type=template&id=24d3b946&scoped=true&"
import script from "./handleInfo.vue?vue&type=script&lang=js&"
export * from "./handleInfo.vue?vue&type=script&lang=js&"
import style0 from "./handleInfo.vue?vue&type=style&index=0&id=24d3b946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3b946",
  null
  
)

export default component.exports